import type { ReactNode } from "react";

export default function ShowcaseRoot({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <div className="bg-[#0d0d0d]">
      <div className="z-20 max-w-7xl px-4 mx-auto flex flex-col justify-between gap-9 py-9 xl:flex-row xl:py-20">
        {children}
      </div>
    </div>
  );
}
